import { create } from 'zustand';

import type { AddDocumentPayload, DocumentStub } from '../docs.types';

export type WebDialogDoc = (DocumentStub | AddDocumentPayload) & {
  revId?: number;
  edit?: boolean;
};

interface WebDialogDocState {
  activeDoc: WebDialogDoc | null;
  setActiveDoc: (doc: WebDialogDoc) => void;
  clearActiveDoc: () => void;
}

export const useWebDialogDocStore = create<WebDialogDocState>((set) => ({
  activeDoc: null,
  setActiveDoc: (activeDoc) => set({ activeDoc }),
  clearActiveDoc: () => set({ activeDoc: null }),
}));
